import { useState } from "react";
import Chart from "react-apexcharts";
import "./DashboardDailyActive.css";

const DashboardDailyActive = () => {
  const [date, setDate] = useState("Last 28 days");
  const [showDate, setShowDate] = useState(false);
  const chooseDropdown = (e) => {
    setDate(e.target.value);
    setShowDate((showDate) => !showDate);
  };
  const [options] = useState({
    chart: {
      type: "bar",
      //   stacked: true,
      toolbar: {
        show: false,
      },
      events: {
        dataPointMouseEnter: function (event) {
          event.path[0].style.cursor = "pointer";
        },
      },
      fontFamily: "poppins",
    },
    grid: {
      padding: {
        top: -10,
        right: 0,
        bottom: -50,
        left: -10,
      },
      show: false, // you can either change hear to disable all grids
    },
    xaxis: {
      labels: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return value.toFixed(0) + " Minutes";
        },
        show: false,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 7,
        columnWidth: "60%",
        distributed: true,
      },
      column: {
        states: {
          hover: {
            color: "#000000",
          },
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      colors: [
        "#cfdbe7",
        "#fb6240",
        "#cfdbe7",
        "#cfdbe7",
        "#cfdbe7",
        "#cfdbe7",
        "#cfdbe7",
        "#cfdbe7",
        "#cfdbe7",
        "#cfdbe7",
        "#cfdbe7",
        "#cfdbe7",
        "#cfdbe7",
        "#cfdbe7",
        "#cfdbe7",
        "#cfdbe7",
        "#cfdbe7",
        "#cfdbe7",
        "#cfdbe7",
        "#cfdbe7",
        "#cfdbe7",
        "#cfdbe7",
        "#cfdbe7",
        "#cfdbe7",
        "#cfdbe7",
        "#cfdbe7",
        "#cfdbe7",
        "#cfdbe7",
      ],
    },
    legend: {
      show: false,
      horizontalAlign: "left",
      position: "top",
      customLegendItems: ["Instagram", "Twitter"],
      fontFamily: "poppins",
      markers: {
        radius: 20,
        fillColors: ["#f14c64", "#1d9bf0"],
      },
      labels: {
        colors: "#757679",
      },
    },
    responsive: [
      {
        breakpoint: 1200,
        options: {
          chart: {
            // width: 200,
            height: 250,
          },
        },
      },
      {
        breakpoint: 550,
        options: {
          chart: {
            // width: 200,
            height: 150,
          },
        },
      },
    ],
  });
  const [series] = useState([
    {
      name: "Specs average rate",
      data: [
        44, 55, 41, 37, 22, 43, 21, 33, 52, 13, 43, 32, 22, 12, 44, 50, 41, 37,
        22, 43, 21, 33, 52, 13, 43, 32, 22, 12,
      ],
    },
  ]);
  return (
    <div className="dashboardDailyActive">
      <div className="dashboardDailyActive__header flex-row">
        <div className="dashboardDailyActive__headerLeft">
          <span>Average daily usage</span>
          <h3>7 hours</h3>
        </div>
        <div className="dashboardDailyActive__dropdown">
          <div
            className={`dropdown-container flex-row ${showDate && "expand"}`}
            onClick={() => setShowDate((showDate) => !showDate)}
          >
            <p>{date}</p>
            <svg
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 4L8 12L16 20"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div
            className={`dropdown-item-container flex-column ${
              showDate && "expand"
            }`}
          >
            <label htmlFor="DateOne">
              <input
                type="radio"
                name="Date"
                id="DateOne"
                value="one"
                onChange={chooseDropdown}
              />
              one
            </label>
            <label htmlFor="DateTwo">
              <input
                type="radio"
                name="Date"
                id="DateTwo"
                value="two"
                onChange={chooseDropdown}
              />
              two
            </label>
            <label htmlFor="DateThree">
              <input
                type="radio"
                name="Date"
                id="DateThree"
                value="three"
                onChange={chooseDropdown}
              />
              three
            </label>
            <label htmlFor="DateFour">
              <input
                type="radio"
                name="Date"
                id="DateFour"
                value="four"
                onChange={chooseDropdown}
              />
              four
            </label>
            <label htmlFor="DateFive">
              <input
                type="radio"
                name="Date"
                id="DateFive"
                value="five"
                onChange={chooseDropdown}
              />
              five
            </label>
          </div>
        </div>
      </div>

      <Chart
        options={options}
        series={series}
        height="250"
        // height="100%"
        // width="100%"
        // width="400"
        type="bar"
      />
    </div>
  );
};

export default DashboardDailyActive;
